import addRoute from '@/router/add-route';

const Products = () => import('@/modules/products/products.vue');
const ProductForm = () => import('@/modules/products/product-form.vue');
const ProductDetails = () => import('@/modules/products/product-details.vue');

const products = [
    addRoute({
        name: 'products',
        path: '/products',
        component: Products,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-product',
        path: '/products/add',
        component: ProductForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'product-details',
        path: '/products/:id',
        component: ProductDetails,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-product',
        path: '/products/update/:id',
        component: ProductForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default products;
